import {
  Backdrop,
  Box,
  // CircularProgress,
  SxProps,
  Typography,
} from "@mui/material";
import { Outlet, useNavigate, useParams } from "react-router-dom";
// import "../../utils/firebaseInit";
import StudySidebar from "./StudySidebar";
// import LogoutContainer from "./LogoutContainer";
import { useEffect, useState } from "react";
import { errorToastMessage } from "../../utils/toast";
import http from "../../utils/http";
import { setRbacState } from "../../Redux/reducers/studySlice";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import {
  reset,
  setFeaturesList,
  setLanguagesList,
  setStudyDetails,
} from "../../Redux/reducers/studySlice";
import { reset as resetAdministrators } from "../../Redux/reducers/administratorsSlice";
import { reset as resetParticipants } from "../../Redux/reducers/participantsSlice";
import { ArrowRight } from "../Common/assets/Icons";
import Loader from "../Common/assets/Loader";
import UserProfileCard from "./UserProfileCard";
// import StudySetupProgress from "./StudySetupProgress";
// import { permissions } from "../../utils/roles";
// import { featuresMap } from "../../utils/features";
// import SocketManager from "./SocketManager";

type Props = {
  name: string;
  status: string;
};

const statusSx: SxProps = {
  textTransform: "capitalize",
  // color: "#FFFFFF",
  borderRadius: "4px",
  px: "5px",
  "&:before": {
    content: '"•"',
    display: "inline-block",
    width: "4px",
    height: "4px",
    borderRadius: "50%",
    mr: "5px",
  },
};

const formatRbacData = (rbac: any) => {
  let studyPermissions: string[] = [];
  let sitePermissions: { [key: string]: string[] } = {};
  let sitesList: any[] = [];
  Object.keys(rbac?.study).forEach((key: string) => {
    if (rbac?.study?.[key]?.permissions) {
      studyPermissions.push(...(rbac?.study?.[key]?.permissions || []));
    }
  });
  sitePermissions = rbac?.site;
  let createParticipant = false;
  let readParticipant = false;
  Object.keys(rbac?.site).forEach((key: string) => {
    const permissions = rbac?.site?.[key].permissions;
    if (permissions?.includes("participant.create")) {
      createParticipant = true;
    }
    if (permissions?.includes("participant.read")) {
      readParticipant = true;
      sitesList.push({
        id: key,
        name: rbac?.site?.[key]?.name,
        isMainSite: rbac?.site?.[key]?.isMainSite,
      });
    }
  });
  if (createParticipant) {
    studyPermissions.push("participant.create");
  }
  if (readParticipant) {
    studyPermissions.push("participant.read");
  }
  return {
    studyPermissions,
    sitePermissions,
    sitesList,
  };
};

const Header: React.FC<Props> = ({ name, status }) => {
  const navigate = useNavigate();
  // const studyPermissions = useAppSelector(
  //   (state) => state.study.studyPermissions
  // );
  // const [canManage, setCanManage] = useState(false);

  // useEffect(() => {
  //   setCanManage(studyPermissions.includes(permissions.studySettings));
  // }, [studyPermissions]);

  const navigateToStudies = () => {
    navigate("/app/studies");
  };

  return (
    <Box
      sx={{
        height: "64px",
        display: "flex",
        alignItems: "center",
        p: "0px 24px",
        bgcolor: "#FFFFFF",
        borderBottom: "1px solid #E5E7EB",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          variant="body1"
          color="text.secondary"
          onClick={navigateToStudies}
          sx={{ cursor: "pointer" }}
        >
          My Studies
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", px: "5px" }}>
          <ArrowRight />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Typography variant="body1" fontWeight="medium" color="primary.main">
            {name}
          </Typography>
          {status && (
            <Typography
              fontSize={10}
              fontWeight="regular"
              bgcolor={
                status === "not_live"
                  ? "#FF7164"
                  : status === "live"
                    ? "#70AE71"
                    : "#F3F4F6"
              }
              color={status === "closed" ? "text.primary" : "#FFFFFF"}
              sx={statusSx}
            >
              {status === "not_live" ? "Not Live" : status}
            </Typography>
          )}
        </Box>
        {/* {name && status === "not_live" && canManage && <StudySetupProgress />} */}
      </Box>
      <Box sx={{ ml: "auto" }}>
        <UserProfileCard collapsed={true} />
      </Box>
    </Box>
  );
};

const StudyLayout = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const toggleLoader = useAppSelector((state) => state.study.toggleLoader);
  // features
  const name = useAppSelector((state) => state.study.name);
  const status = useAppSelector((state) => state.study.status);

  useEffect(() => {
    const fetchStudy = async () => {
      try {
        setLoading(true);
        const res = await http.get(`/study/${id}/configurations`);
        const res2 = await http.get(`/roles/self-rights?studyId=${id}`);
        const { studyPermissions, sitePermissions, sitesList } = formatRbacData(
          res2?.data?.data,
        );
        dispatch(
          setRbacState({ studyPermissions, sitePermissions, sitesList }),
        );
        const { status, name, themeSettings, settings, closedOn } =
          res.data.data;
        dispatch(
          setStudyDetails({
            status: status,
            dataEditable: !closedOn,
            primaryColor: themeSettings?.colorConfig?.primaryColor || "#327091",
            secondaryColor:
              themeSettings?.colorConfig?.secondaryColor || "#E3F1F4",
            textColor: themeSettings?.colorConfig?.textColor || "#111928",
            secondaryTextColor:
              themeSettings?.colorConfig?.secondaryTextColor || "#6B7280",
            backgroundColor:
              themeSettings?.colorConfig?.backgroundColor || "#F4F5F7",
            name: name,
            subjectIdGeneration: settings?.subjectIdStrategy || "free_text",
            displayLogic: settings?.displayLogicStrategy || "",
          }),
        );

        dispatch(
          setFeaturesList(
            Object.keys(res.data?.data?.features || {}).length === 0
              ? { survey: true }
              : res.data?.data?.features,
          ),
        );
        dispatch(setLanguagesList(res.data?.data?.languages || []));
        setLoading(false);
      } catch (err) {
        navigate("/app/studies");
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };
    fetchStudy();
  }, [setLoading, id, dispatch, toggleLoader]);

  useEffect(() => {
    return () => {
      dispatch(reset());
      dispatch(resetAdministrators());
      dispatch(resetParticipants());
    };
  }, [dispatch]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          height: "100%",
          "& .svgicon.stroke": {
            stroke: (theme) => theme.palette.text.secondary,
          },
          "& .svgicon.fill": {
            fill: (theme) => theme.palette.text.secondary,
          },
          "& .svgicon-primary.fill": {
            fill: (theme) => theme.palette.primary.main,
          },
          "& .svgicon-primary.stroke": {
            stroke: (theme) => theme.palette.primary.main,
          },
          "& .svgicon-tprimary.stroke": {
            stroke: (theme) => theme.palette.text.primary,
          },
          "& .svgicon-tprimary.fill": {
            fill: (theme) => theme.palette.text.primary,
          },
        }}
      >
        <StudySidebar />
        <Box
          sx={{
            flex: 1,
            minWidth: "1px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {loading && (
            <Backdrop
              open={true}
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            >
              <Loader />
            </Backdrop>
          )}
          <Header name={name} status={status} />
          <Box
            sx={{
              flex: 1,
              minHeight: "1px",
              // backgroundColor: backgroundColor,
            }}
          >
            {!loading && <Outlet />}
          </Box>
        </Box>
      </Box>
      {/* {!loading && features?.[featuresMap.messages] && <SocketManager />} */}
    </>
  );
};

export default StudyLayout;
